import { useQuery } from '@tanstack/react-query';
import { tenantApi } from '@/modules/tenant/services/tenantApi';

export interface CanonicalManufacturerOption {
  id: string;
  name: string;
}

/**
 * #706 — canonical manufacturer options for brand pickers (Core-served,
 * ungated `/canonical-manufacturers`). Fetch-once + client-side filtering,
 * same pattern as Inventory's useManufacturerOptions.
 */
export function useCanonicalManufacturers(category: 'boat' | 'engine' = 'boat') {
  return useQuery({
    queryKey: ['canonical-manufacturers', category],
    queryFn: () =>
      tenantApi.getList<CanonicalManufacturerOption>(
        `/canonical-manufacturers?category=${category}`
      ),
    staleTime: 5 * 60_000,
  });
}
